import { css } from '@emotion/react'
import { RadiusToken } from '@livechat/design-system-react-components'

import { type IApplication } from '@/apis/apps/interfaces'
import ProductCard from '@/components/Product/Card'

const productCardCss = css`
  display: flex;

  > div:first-of-type {
    margin-left: 0;
  }

  .item-card-base {
    width: 100%;
    text-align: left;
    margin: 0;
  }

  img {
    border-radius: var(${RadiusToken.Radius2});
  }
`

interface Props {
  app: IApplication
}

const DevProductCard = ({ app }: Props) => (
  <div css={productCardCss}>
    <ProductCard app={app} key={app.id} />
  </div>
)

export default DevProductCard
